// Central mapping between the i18n language codes and the SEO URL prefixes.
// Italian is served at the site root (no prefix); the other languages live
// under a stable path prefix. Slugs after the prefix are identical (Option A).
export const URL_LANGS = [
  { code: "it", prefix: "", htmlLang: "it", hreflang: "it", ogLocale: "it_IT" },
  { code: "en", prefix: "/en", htmlLang: "en", hreflang: "en", ogLocale: "en_US" },
  { code: "es", prefix: "/es", htmlLang: "es", hreflang: "es", ogLocale: "es_ES" },
  { code: "pt", prefix: "/pt-br", htmlLang: "pt-BR", hreflang: "pt-BR", ogLocale: "pt_BR" },
];

// Detect the active language from a full pathname (prefix included).
export const langFromPath = (pathname = "/") => {
  const p = (pathname || "/").toLowerCase();
  for (const l of URL_LANGS) {
    if (l.prefix && (p === l.prefix || p.startsWith(`${l.prefix}/`))) return l;
  }
  return URL_LANGS[0]; // italian (root)
};

export const prefixFor = (code) => (URL_LANGS.find((l) => l.code === code) || URL_LANGS[0]).prefix;
